import { IDefaultRequestProps } from "types/general/GeneralStateModelInterfaces";
import { CaseReducer, PayloadAction, Draft } from "@reduxjs/toolkit";
import RequestStatus from "types/general/requests/RequestStatus";

export interface GenericDataState<T> extends IDefaultRequestProps
{
	data: T
}

export function createSetFetchDataPendingReducer<T>(): CaseReducer<GenericDataState<T>>
{
	const setFetchDataPendingReducer: CaseReducer<GenericDataState<T>> = <T>(state: Draft<GenericDataState<T>>) =>
	{
		state.requestStatus = RequestStatus.pending;
		state.error = null;
	}
	return setFetchDataPendingReducer;
}

export function createSetFetchDataSuccesReducer<T>(): CaseReducer<GenericDataState<T>, PayloadAction<{ data: T }>>
{
	const setFetchDataSuccesReducer: CaseReducer<GenericDataState<T>, PayloadAction<{ data: T }>> = (state: Draft<GenericDataState<T>>, action: PayloadAction<{ data: T }>) =>
	{
		state.requestStatus = RequestStatus.succes;
		state.data = action.payload.data as Draft<T>;
	}
	return setFetchDataSuccesReducer;
}

export function createSetFetchDataErrorReducer<T>(): CaseReducer<GenericDataState<T>, PayloadAction<{ error: string }>>
{
	const setFetchDataErrorReducer: CaseReducer<GenericDataState<T>, PayloadAction<{ error: string }>> = (state: Draft<GenericDataState<T>>, action: PayloadAction<{ error: string }>) =>
	{
		console.error(action.payload.error);
		state.requestStatus = RequestStatus.error;
		state.error = action.payload.error;
	}
	return setFetchDataErrorReducer;
}

export function createResetRequestStatusReducer<T>(): CaseReducer<GenericDataState<T>>
{
	const setFetchDataPendingReducer: CaseReducer<GenericDataState<T>> = <T>(state: Draft<GenericDataState<T>>) =>
	{
		state.requestStatus = RequestStatus.idle;
		state.error = null;
	}
	return setFetchDataPendingReducer;
}

// https://redux-toolkit.js.org/usage/usage-with-typescript/

/*
const createGenericDataSlice = <
	T,
	Reducers extends SliceCaseReducers<GenericDataState<T>>>
	({
		name = '',
		initialState,
		reducers
	}: {
		name: string,
		initialState: GenericDataState<T>,
		reducers: ValidateSliceCaseReducers<GenericDataState<T>, Reducers>
	}) => {
	return createSlice({
		name,
		initialState,
		reducers: {
			pending: createSetFetchDataPendingReducer(),
			succes: createSetFetchDataSuccesReducer(),
			error: createSetFetchDataErrorReducer(),
			...reducers
		}
	});
}


const create2GenericDataSlice = <T, Reducers extends SliceCaseReducers<GenericDataState<T>>>(
	name: string,
	initialState: GenericDataState<T>,
	reducers: ValidateSliceCaseReducers<GenericDataState<T>, Reducers>,
	pendingReducerActionKey: string,
	succesReducerActionKey: string,
	errorReducerActionKey:string
) => {
	return createSlice({
		name,
		initialState,
		reducers: {
			[pendingReducerActionKey]: createSetFetchDataPendingReducer<T>(),
			[succesReducerActionKey]: createSetFetchDataSuccesReducer<T>(),
			[errorReducerActionKey]: createSetFetchDataErrorReducer<T>(),
			...reducers
		}
	});
}

export { createGenericDataSlice, create2GenericDataSlice };
*/